import { useEffect } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../../meta';
import { getGutter, getImagesByQuality, getQuality } from '../../../helpers';
import { useResizeWidth } from '../../../utils';
import { ItemData } from '../../items/ItemData';

export const Panoramic = ({ mobile, tablet, images, reportVisibleImages }) => {
  const settings = useSettings();
  const { measureRef, width } = useResizeWidth();
  const quality = getQuality(width);
  const currentImages = getImagesByQuality(images, quality);

  useEffect(() => {
    reportVisibleImages(images.map(({ id }) => id));
  }, [images, reportVisibleImages]);

  const gutter = (() => {
    const gutters = getGutter(settings);

    if (mobile) {
      return gutters.mobile;
    }

    if (tablet) {
      return gutters.tablet;
    }

    return gutters.default;
  })();

  return (
    <div className={`${meta.stylePrefix}-panoramic-component`} ref={measureRef}>
      {currentImages?.map((item, index) => (
        <Item key={item.id} $gutter={gutter}>
          <ItemData
            data={item}
            infoClassName={`${meta.stylePrefix}-panoramic-info`}
            id={index}
          />
        </Item>
      ))}
    </div>
  );
};

const Item = styled.div.attrs({
  className: `${meta.stylePrefix}-panoramic-item`
})`
  display: block;

  &:not(:last-child) {
    margin-bottom: ${({ $gutter }) => ($gutter ? `${$gutter}px` : '0')};
  }

  & .${meta.stylePrefix}-panoramic-info {
    padding: 0 20px;
  }
`;
